import Api from '@/services/Api'

const resource = 'becarios'

export default {
  listBecarios(listQuery) {
    return Api().get(`${resource}`, {
      params: {
        limit: listQuery.limit,
        offset: listQuery.limit * listQuery.page - listQuery.limit,
        query: listQuery.query,
        ordering: listQuery.ordering,
        generacion: listQuery.generacion,
        ...listQuery.filter,
      },
    })
  },

  getBecariosByGeneracion(generacionId) {
    return Api().get(`${resource}`, {
      params: {
        limit: 150,
        generacion: generacionId,
      },
    })
  },
  getBecario(id) {
    return Api().get(`${resource}/${id}/`)
  },
  addBecario(form) {
    return Api().post(`${resource}/`, form)
  },
  setBecarioToGeneration(id, generationId) {
    return Api().patch(`${resource}/${id}/`, {
      generacion_id: generationId,
    })
  },
  setData(id, data) {
    return Api().patch(`${resource}/${id}/`, data)
  },
}
